import React, { useRef } from 'react';
import { FiCheck, FiTrash2, FiUpload } from 'react-icons/fi';
import { PickedFile, pickedFrom } from './governanceData';

// hidden file input behind a button; hands back the chosen file
export const FilePick: React.FC<{ className: string; accept?: string; onPick: (f: PickedFile) => void }> = ({ className, accept, onPick, children }) => {
    const input = useRef<HTMLInputElement>(null);
    return <>
        <button type="button" className={className} onClick={() => input.current?.click()}>{children}</button>
        <input ref={input} type="file" hidden accept={accept} onChange={e => {
            const f = e.target.files?.[0];
            e.target.value = '';
            if (f) onPick(pickedFrom(f));
        }} />
    </>;
};

export const DOC_TYPES = '.pdf,.doc,.docx,.xls,.xlsx';

// the green "file is in" box at the top of the upload / edit modals; onReplace adds a Replace File button
export const FileBox: React.FC<{ file: string; sub: string; onRemove: () => void; removeLabel: string; onReplace?: (f: PickedFile) => void }> = ({ file, sub, onRemove, removeLabel, onReplace }) =>
    <div className="hub-file-box">
        <span className="hub-file-ok"><FiCheck /></span>
        <span className="hub-file-text"><strong>{file}</strong><span>{sub}</span></span>
        {onReplace && <FilePick className="hub-small-btn" accept={DOC_TYPES} onPick={onReplace}>Replace File</FilePick>}
        <button type="button" className="hub-icon-btn danger" aria-label={removeLabel} title={removeLabel} onClick={onRemove}><FiTrash2 /></button>
    </div>;

// the empty state before a file is chosen
export const FileDrop: React.FC<{ onPick: (f: PickedFile) => void }> = ({ onPick }) =>
    <div className="hub-file-drop">
        <FiUpload />
        <span>PDF, Word or Excel · up to 25 MB</span>
        <FilePick className="btn-outline with-icon" accept={DOC_TYPES} onPick={onPick}><FiUpload /> Choose a File</FilePick>
    </div>;
